import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import { createElement, PureComponent } from 'react';
import icons from '../icons';
import { datepickerClass } from './styles';
var DefaultValue = {
  tag: 'span'
};

var Icon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  var _super = _createSuper2(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          name = _this$props.name,
          onClick = _this$props.onClick,
          tag = _this$props.tag,
          disabled = _this$props.disabled;
      var newProps = {
        className: datepickerClass(className, 'icon', disabled && 'disabled'),
        onClick: disabled ? undefined : onClick
      };
      return (
        /*#__PURE__*/
        createElement(tag, newProps, icons[name])
      );
    }
  }]);

  return Icon;
}(PureComponent);

Icon.defaultProps = DefaultValue;
export default Icon;